import { isLanguageSwitcherEnabled } from '@/lib/i18n-config';
import { I18nProvider } from '@kgc/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { consoleCapture, networkCapture } from './components/helpdesk';
// R-7(a) (kör-71): a `.font-mono-num` eddig NÉV SZERINT kérte a JetBrains Mono-t, de fájl
// sehonnan nem érkezett ⇒ minden gépen a fallback renderelt. Self-host (OFL-1.1), nem CDN:
// a PWA offline is ugyanazt a számjegy-képet adja. A súlyok a mono-osztályok mellett mért
// `normal · medium · semibold` + az öröklődhető `bold`; a subsetet a `unicode-range` tölti lustán.
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import '@fontsource/jetbrains-mono/700.css';
import './index.css';
import { startMockApi } from './mocks/start-mock-api';

// Helpdesk auto-capture init — app bootstrap-kor, mindent fog indulástól
consoleCapture.init();
networkCapture.init();

function render() {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  createRoot(rootElement).render(
    <StrictMode>
      <I18nProvider honorPersistedLocale={isLanguageSwitcherEnabled()}>
        <App />
      </I18nProvider>
    </StrictMode>
  );
}

// Day-1-unblock: dev-módban mock-API indul (ha VITE_USE_REAL_API!=true), majd render.
// Prod-build / VITE_USE_REAL_API=true esetén a startMockApi azonnal no-op → változatlan viselkedés.
void startMockApi().finally(render);
